// removed by extract-text-webpack-plugin
module.exports = {"ratings":"Ratings__ratings___-RNoc","text":"Ratings__text___1lKvt","icon":"Ratings__icon___29E1Q"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/reviews/components/Ratings.scss
// module id = 1636
// module chunks = 0